import React from 'react'
import PropTypes from 'prop-types'

import { DescriptionIcon } from '@wf-sl/common-icons'
import Tooltip from '../tooltip/tooltip'

import styles from './field-label.module.css'

const propTypes = {
    children: PropTypes.node,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipClassName: PropTypes.string
}

function FieldLabel({ children, label, tooltip, tooltipClassName }) {
    const labelDiv = tooltip ? (
        <Tooltip className={tooltipClassName} content={tooltip} placement="top">
            <div className={styles['label-tooltip']}>
                {label}
                <DescriptionIcon className={styles['description-icon']} />
            </div>
        </Tooltip>
    ) : (
        label
    )

    return (
        <label className={styles['field-label']}>
            <div className={styles['caption']}>{labelDiv}</div>
            {children}
        </label>
    )
}

FieldLabel.propTypes = propTypes

export default FieldLabel
